import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'triider-components';
import OrdersColumn from './OrdersColumn';
import ChatColumn from './ChatColumn';
import ProProfileColumn from './ProProfileColumn';

import {
  OrderCard,
  Container,
  ContentTab,
} from './styles';

const OrderTab = ({
  taskDetail,
  loadingVisible,
}) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(loadingVisible);
  }, [loadingVisible]);

  return isLoading ? (
    <Container>
      <Spinner size="large" />
    </Container>
  ) : (
    <>
      <OrderCard canceled={taskDetail.status === 'canceled'}>
        {taskDetail && taskDetail.quotes && taskDetail.quotes.length > 0 ? (
          <ContentTab>
            <OrdersColumn />
            <ChatColumn />
            <ProProfileColumn />
          </ContentTab>
        ) : (
          <Container>
            {taskDetail && taskDetail.service_name && taskDetail.address ? (
              <p>
                {`O pedido ${taskDetail.service_name}`}
                <br />
                {`para ${taskDetail.address}`}
                <br />
                ainda não recebeu orçamentos.
              </p>
            ) : (
              <p>O pedido ainda não recebeu orçamentos</p>
            )}
          </Container>
        )}
      </OrderCard>
    </>
  );
};

const mapStateToProps = state => ({
  taskDetail: state.task.taskDetail,
  loadingVisible: state.ui.loaders.includes('TASK_DETAIL'),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(OrderTab);
